function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "#clip0"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1482 2.63249C18.4772 2.91322 17.7598 3.1028 17.0039 3.1903C17.7752 2.7528 18.3692 2.06009 18.6469 1.23613C17.9257 1.64082 17.1273 1.93613 16.275 2.0929C15.5923 1.40384 14.6204 0.973633 13.5482 0.973633C11.4849 0.973633 9.81491 2.55592 9.81491 4.50645C9.81491 4.78353 9.84576 5.05332 9.91133 5.31217C6.80664 5.16634 4.05293 3.75905 2.21326 1.61895C1.89315 2.1403 1.70802 2.74915 1.70802 3.39447C1.70802 4.61947 2.37138 5.70228 3.37414 6.33665C2.75706 6.32207 2.17855 6.16165 1.67717 5.89551C1.67717 5.91009 1.67717 5.92467 1.67717 5.93926C1.67717 7.6528 2.96532 9.07832 4.67386 9.4028C4.36147 9.48301 4.02978 9.52676 3.69039 9.52676C3.45127 9.52676 3.21601 9.50488 2.98846 9.46113C3.46284 10.8648 4.84356 11.8856 6.47882 11.9148C5.20224 12.8627 3.59012 13.4278 1.83915 13.4278C1.53832 13.4278 1.24136 13.4096 0.948242 13.3768C2.59507 14.3903 4.55816 14.9736 6.66394 14.9736C13.5405 14.9736 17.297 9.58874 17.297 4.91842C17.297 4.7653 17.2931 4.61217 17.2854 4.4627C18.0144 3.96322 18.6469 3.34342 19.1482 2.63249Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 15,
  fill: "white",
  transform: "translate(0.00488281 0.807617)"
})));

function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e044692c.svg";
export { ForwardRef as ReactComponent };